module.exports = __webpack_public_path__ + "static/media/welcome.4cda1ae5.mp4";